import { Vue, Component } from "@wagich/vue-facing-decorator-metadata";

import { render } from "./event-overview.html";
import { type TimelineModel } from "../models/Events";
import { EventTimeline } from "~/vue/event-timeline";

@Component({
	render,
	components: {
		EventTimeline,
	},
})
export class EventOverview extends Vue {
	activeView: number = 0; // 1: list, 2: timeline
	timelineData: TimelineModel = { shows: [], isClosestShowBeforeToday: false };

	get hasTimelineData(): boolean {
		return this.timelineData.shows.length > 0;
	}

	mounted() {
		const dataElement = document.querySelector<HTMLScriptElement>('script[type="application/json"][data-timeline]');
		if (dataElement != null && dataElement.textContent) {
			try {
				this.timelineData = JSON.parse(dataElement.textContent) as TimelineModel;
			} catch {
				// keep empty default; list fallback remains visible
			}
		}
	}
}
